import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { contractOverviewPageQueryOptions } from "~/app/api/pageData/contractOverviewPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createContractOverviewPage } from "~/pages/ContractOverviewPage/ContractOverviewPage";

const CONTRACT_OVERVIEW_PATH = "/my-account/contractOverview";

function ContractOverviewRoute() {
  const result = useLoaderData({
    from: CONTRACT_OVERVIEW_PATH,
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createContractOverviewPage()}
    </StorefrontShellFrame>
  );
}

export async function loadContractOverviewPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(contractOverviewPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const contractOverviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: CONTRACT_OVERVIEW_PATH,
  loader: async ({ context }) => loadContractOverviewPageData(context),
  component: ContractOverviewRoute,
});
